module.exports = {
    RECEIVE_VIGILANCES: 'RECEIVE_VIGILANCES',
}
